import { Callout, Card, ProgressBar } from "@blueprintjs/core";
import { Copyright, Logo } from "@package/ui-components";
import { ErrorFields } from "../ErrorFields/ErrorFields";

type LoginProps = {
  error?: string;
};

export function Login({ error }: LoginProps) {
  return (
    <div className="flex justify-center">
      <div className="mt-8">
        <Card className="p-16" elevation={2}>
          <Logo />
          <ErrorFields />
          <div className="mt-12">
            <ProgressBar
              animate={!error}
              intent={error ? "danger" : "primary"}
              stripes={!error}
              value={1}
            />
          </div>
          {error ? (
            <Callout
              className="mt-4"
              intent="danger"
              title="Failed Authentication"
            >
              {error}
            </Callout>
          ) : (
            <div className="mt-4 text-center">
              {error ? "Failed" : "Authenticating..."}
            </div>
          )}
          <div className="mt-16 text-center">
            <Copyright />
          </div>
        </Card>
      </div>
    </div>
  );
}
